export const GET_LESSON_CATEGORIES = 'lessonCategories/GET_LESSON_CATEGORIES';
export const UPDATE_LESSON_CATEGORY_BY_ID =
  'lessonCategories/UPDATE_LESSON_CATEGORY_BY_ID';
export const REMOVE_LESSON_CATEGORY_BY_ID =
  'lessonCategories/REMOVE_LESSON_CATEGORY_BY_ID';
